import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ClipboardCheck, RefreshCcw, Stethoscope, Layers, HeartPulse } from "lucide-react";
import { buttonVariants, cn } from "@dosa/ui";

const services = [
  { key: "initialMtm", icon: ClipboardCheck },
  { key: "followUp", icon: RefreshCcw },
  { key: "postDischarge", icon: Stethoscope },
  { key: "polypharmacy", icon: Layers },
  { key: "chronic", icon: HeartPulse },
] as const;

export function ServicesPage() {
  const { t } = useTranslation();
  return (
    <div className="container-app py-16 lg:py-20">
      <h1 className="text-4xl font-semibold text-charcoal-900">{t("services.title")}</h1>
      <p className="mt-3 max-w-2xl text-lg text-charcoal-600">{t("services.subtitle")}</p>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s) => (
          <div key={s.key} className="flex flex-col rounded-lg border border-charcoal-100 bg-white p-6 shadow-card">
            <div className="mb-4 inline-flex w-fit rounded-md bg-primary-50 p-2.5 text-primary-700">
              <s.icon className="h-5 w-5" />
            </div>
            <h3 className="font-semibold text-charcoal-800">{t(`services.${s.key}.title`)}</h3>
            <p className="mt-1.5 flex-1 text-sm text-charcoal-500">{t(`services.${s.key}.body`)}</p>
            <Link to="/book-a-review" className={cn(buttonVariants({ variant: "outline", size: "sm" }), "mt-4 self-start")}>
              {t("nav.bookReview")}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
